// generate an ID that is, to all intents and purposes, unique
export const id = (Math.round(Math.random() * 1e20)).toString(36);
export const re = new RegExp(`_${id}_(?:(\\d+)|(AT)|(HASH))_(\\w+)?`, 'g');
